import { render, staticRenderFns } from "./submit-user-pane.vue?vue&type=template&id=bbdec97e&scoped=true"
import script from "./submit-user-pane.vue?vue&type=script&lang=js"
export * from "./submit-user-pane.vue?vue&type=script&lang=js"
import style0 from "./submit-user-pane.vue?vue&type=style&index=0&id=bbdec97e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbdec97e",
  null
  
)

export default component.exports